import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';

import { WxProvider } from '../../providers/wx/wx';
import { UtilProvider } from '../../providers/util/util';
import { MyPhotoClipComponent } from '../../components/my-photo-clip/my-photo-clip';

/**
 * Generated class for the PhotoclipPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-photoclip',
  templateUrl: 'photoclip.html',
})
export class PhotoclipPage {
  @ViewChild(MyPhotoClipComponent) clipper;

  qr_code: string;

  //剪裁回调
  onClipFinished: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public wxService: WxProvider,
    public platform: Platform,
    public util: UtilProvider
  ) {
    // navCtrl.pop()
    this.qr_code = navParams.get('qrCode');
    this.onClipFinished = navParams.get('onClipFinished');
    console.log('photoClip:' + this.qr_code);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PhotoclipPage');
    // new PhotoClip('#clipArea', {
    //   size: [370, 637], //裁剪框大小
    //   outputSize: [0, 0], //打开图片大小，[0,0]表示原图大小
    //   // file: "#file",
    //   // ok: "#clipBtn",
    //   img: './assets/imgs/bot-nor.jpeg',
    //   // loadStart: function() { //图片开始加载的回调函数。this 指向当前 PhotoClip 的实例对象，并将正在加载的 file 对象作为参数传入。（如果是使用非 file 的方式加载图片，则该参数为图片的 url）
    //   //   $(".loading").removeClass("displaynone");
    //   //
    //   // },
    //   // loadComplete: function() {//图片加载完成的回调函数。this 指向当前 PhotoClip 的实例对象，并将图片的 <img> 对象作为参数传入。
    //   //   $(".loading").addClass("displaynone");
    //   //
    //   // },
    //   // done: function(dataURL) { //裁剪完成的回调函数。this 指向当前 PhotoClip 的实例对象，会将裁剪出的图像数据DataURL作为参数传入。
    //   //   console.log(dataURL);//dataURL裁剪后图片地址base64格式提交给后台处理
    //   //   // $(".clipbg").fadeOut()
    //   // }
    // });
  }

  // getClipBase64(postImgUrl) {
  //   console.log('outman marking');
  //
  //
  // }

  goBack() {
    this.util.goBack(this.navCtrl);
  }

  finishClip() {
    this.clipper.changeToImg().then(canvas => {
      // var img = canvas.toDataURL();
      // var a = document.createElement('a');
      // a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      // a.download = '独到科技-紫豆助手-'+this.chatroom.nick_name+'.jpg';
      // a.click();
      // console.log(canvas.toDataURL());
      // this.base64Img = canvas.toDataURL();
      // this.is_show_img = true;
      // this.is_change_to_img = false;
      this.onClipFinished(canvas.toDataURL());
      this.goBack();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/photoclip/photoclip.ts